import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { HEADER_HEIGHT } from '../App';
import { usePageMeta } from '../hooks/usePageMeta';

const PrivacyPolicy: React.FC = () => {
  usePageMeta(
    'Privacy Policy | Good Shepherd Accounting',
    'How Good Shepherd Accounting collects, uses and protects your personal information.'
  );
  return (
    <Box
      sx={{
        minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: 'rgba(27,60,105,0.02)',
        py: 8
      }}
    >
      <Container maxWidth="lg">
        <Paper sx={{ p: 6, borderRadius: 2 }}>
          <Typography variant="h3" gutterBottom color="primary.main" sx={{ mb: 4 }}>
            Privacy Policy
          </Typography>

          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString('en-AU')}
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            1. Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            We are committed to protecting your privacy and handling your personal information in accordance with the Privacy Act 1988 (Cth) (Privacy Act), the Australian Privacy Principles (APPs), and other relevant legislation.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            2. What Personal Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect personal information that is reasonably necessary for our business functions. This may include:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Name and contact details</Typography>
            <Typography component="li" variant="body1">Financial information for calculator usage</Typography>
            <Typography component="li" variant="body1">Information about your use of our calculators and services</Typography>
            <Typography component="li" variant="body1">Device information and usage data when you use our website</Typography>
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            3. How We Collect Information
          </Typography>
          <Typography variant="body1" paragraph>
            We collect information through:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Direct interactions with our calculators and services</Typography>
            <Typography component="li" variant="body1">Automated technologies or interactions (cookies, usage data)</Typography>
            <Typography component="li" variant="body1">Third parties or publicly available sources</Typography>
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            4. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use your information to:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Provide and improve our calculator services</Typography>
            <Typography component="li" variant="body1">Analyze usage patterns to enhance user experience</Typography>
            <Typography component="li" variant="body1">Communicate important updates or changes to our services</Typography>
            <Typography component="li" variant="body1">Comply with legal obligations</Typography>
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            5. Disclosure of Personal Information
          </Typography>
          <Typography variant="body1" paragraph>
            We may disclose your personal information to:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Our service providers who assist in operating our website</Typography>
            <Typography component="li" variant="body1">Law enforcement or government agencies where required by law</Typography>
            <Typography component="li" variant="body1">Other parties with your express consent</Typography>
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            6. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            We take reasonable steps to protect your personal information from misuse, interference, loss, unauthorized access, modification, or disclosure. However, no internet-based service can be guaranteed as 100% secure.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            7. Cookies and Analytics
          </Typography>
          <Typography variant="body1" paragraph>
            We use cookies and similar technologies to improve your experience on our website. You can control cookies through your browser settings. We also use analytics services to understand how our website is used.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            8. Access and Correction
          </Typography>
          <Typography variant="body1" paragraph>
            You have the right to access and correct your personal information held by us. To make a request, please contact us using the details below.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            9. Complaints
          </Typography>
          <Typography variant="body1" paragraph>
            If you believe we have breached your privacy rights, you can make a complaint to us. If you're not satisfied with our response, you can contact the Office of the Australian Information Commissioner (OAIC).
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            10. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update this privacy policy from time to time. Any changes will be posted on this page with an updated revision date.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            11. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this privacy policy or our handling of your personal information, please contact us at:
          </Typography>
          <Typography variant="body1" component="div" sx={{ pl: 4 }}>
            Email: nancy@gsaccountants.com.au<br />
            Phone: 0425 660 773<br />
            Address: Turvey St, Padstow NSW
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy; 